import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, useQueryClient, UseMutationResult } from 'react-query';
import { Document, DocumentWrite, ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useCreateDocument(): UseMutationResult<
  AxiosResponse<Document>,
  AxiosError<ErrorMessage>,
  DocumentWrite
> {
  const queryClient = useQueryClient();

  const createDocument = (document: DocumentWrite): Promise<AxiosResponse<Document>> => {
    return client.post('documents/', document);
  };

  return useMutation(createDocument, {
    onSuccess: () => {
      queryClient.invalidateQueries('documents');
    },
  });
}
